
// const featuresImgPathArr = ['./images/feature1.png','./images/feature2.png','./images/feature3.png','./images/feature4.png'];
export const achievementsArr = [
    {
        "id": 1,
        "src": "images/achievement1.png",
        "value": 4609,
        "title": "Works"
    },{
        "id": 2,
        "src": "images/achievement2.png",
        "value": 3470,
        "title": "Customers"
    },{
        "id": 3,
        "src": "images/achievement3.png",
        "value": 2908,
        "title": "Purchase"
    },{
        "id": 4,
        "src": "images/achievement4.png",
        "value": 1908,
        "title": "Office"
    }
];


// WEBPACK FOOTER //
// ./src/data/achievementsArr.js